import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import SeoGuidesSection from './components/SeoGuidesSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.asia';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'KakobuyFinds',
  url: siteUrl,
  description: 'Discover the ultimate Kakobuy Spreadsheet database with thousands of organized product finds, updated spreadsheets, category guides, and shopping resources. Your complete guide to verified Kakobuy Finds in 2026.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: siteUrl + '/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'KakobuyFinds',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Kakobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Kakobuy Spreadsheet is a structured product discovery database that organizes verified shopping finds into clean, searchable categories. It helps shoppers quickly find, compare, and save interesting products without endless browsing.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Kakobuy Spreadsheet free to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, the Kakobuy Spreadsheet is completely free to browse and use. You can explore product categories, view organized finds, and access shopping guides at no cost. Visit the main website to start discovering products today.',
      },
    },
    {
      '@type': 'Question',
      name: 'How often is the Kakobuy Spreadsheet updated?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Kakobuy Spreadsheet is updated on a daily basis with new verified product finds, trending items, and refreshed category data. The community actively contributes new discoveries to keep the database current and comprehensive.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Kakobuy safe for online shopping?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. Kakobuy Spreadsheet includes verified product listings with quality checks and community reviews. However, always practice safe online shopping habits — verify sellers, check product details, and use secure payment methods.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the alternatives to Kakobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Popular alternatives include CSSBuy Spreadsheet, Superbuy Spreadsheet, and Oopbuy Spreadsheet. Each platform has unique features, but Kakobuy Spreadsheet stands out for its organized category system, daily updates, and user-friendly interface.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I contribute products to the Kakobuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Kakobuy Spreadsheet community welcomes contributions. Visit the main website at kaspreadsheet.com to learn how you can share your product discoveries with other shoppers and help the database grow.',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <SeoGuidesSection />
        <TestimonialSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}